import { useCallback, useState } from 'react';

type TableStortState = {
  col: number;
  ascending: boolean;
};

export const useTableSortState = (initState: TableStortState) =>
  useState<TableStortState>(initState);

export const useTableSortCallback = <T extends unknown>(
  sort: (col: number, a: T, b: T) => number,
) =>
  useCallback(
    (col: number, ascending: boolean, listToSort: T[]) =>
      [...listToSort].sort((a, b) =>
        ascending ? sort(col, b, a) : sort(col, a, b),
      ),
    [sort],
  );

export const useTableSortCompare = (
  locale: string,
): ((x: string, y: string) => number) => Intl.Collator(locale || 'nb').compare;
